<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
                Buscar
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Fecha Cita</th>
          <th scope="col">Hora</th>
          <th scope="col">Especialidad</th>
          <th scope="col">Médico</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="atencion in datosPaginados" :key="atencion.idAtencion">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(atencion.idAtencion)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ getFormattedDate(atencion.fechaCita, "DD/MM/YYYY") }}</td>
          <td>{{ atencion.horaDesde }}</td>
          <td>{{ atencion.nombreEspecialidad }}</td>
          <td>{{ atencion.nombreMedico }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteAtencion(atencion.idAtencion)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPaginaTodos(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idAtencion" class="form-label"
                      >IdAtencion</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idAtencion"
                      name="idAtencion"
                      v-model="datoAtencion.idAtencion"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombreMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombreMedico"
                      name="nombreMedico"
                      v-model="datoAtencion.nombreMedico"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombreEspecialidad" class="form-label">
                      Especialidad</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombreEspecialidad"
                      name="nombreEspecialidad"
                      v-model="datoAtencion.nombreEspecialidad"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="motivo" class="form-label">Motivo</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="motivo"
                      name="motivo"
                      v-model="datoAtencion.motivo"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="cuadro" class="form-label">Cuadro</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      id="cuadro"
                      name="cuadro"
                      v-model="datoAtencion.cuadro"
                      disabled
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="observacion" class="form-label"
                      >Observación</label
                    >
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      id="observacion"
                      name="observacion"
                      v-model="datoAtencion.observacion"
                      disabled
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label"
                      >Fecha de registro</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      :value="getFormattedDate(datoAtencion.fechaReg)"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaAct"
                      name="fechaAct"
                      :value="getFormattedDate(datoAtencion.fechaAct)"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import { decodificarTipoCita } from "@/modules/decode.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
export default {
  props: {
    p_idPersona: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      atencions: [],
      datoAtencion: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      personas: [],
      medicos: [],
      citas: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
  },
  methods: {
    descTipoCita(codigo) {
      return decodificarTipoCita(codigo);
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.atencions.length / this.elementosPorPagina);
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwatencions/idpersona/" +
            this.p_idPersona
        )
        .then((response) => {
          this.atencions = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.atencions.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    abrirModalEditar(idAtencion) {
      this.modalWindow = true;
      if (idAtencion != null) {
        api.get("/vwatencions/" + idAtencion)
          .then((resp) => {
            this.datoAtencion = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Resumen de la atención";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    async deleteAtencion(idAtencion) {
      try {
        await api.delete("/atencions/" + idAtencion
        );
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
  },
};
</script>
